import React, { useEffect, useMemo } from 'react';
import { useLinkPreviewCache } from './LinkPreviewContext';

interface LinkPreviewProps {
    url: string;
    handleLinkClick: (event, url) => void
}

const LinkPreview: React.FC<LinkPreviewProps> = ({ url, handleLinkClick }) => {
    const { cache, loadingUrls, setCache, setLoading } = useLinkPreviewCache();

    // Validate URL
    const isValidUrl = useMemo(() => {
        try {
            new URL(url);
            return true;
        } catch {
            return false;
        }
    }, [url]);

    useEffect(() => {
        if (!isValidUrl || cache[url] || loadingUrls.has(url)) return;

        setLoading(url, true);
        fetch(`https://linkpreview-572629051811.us-central1.run.app/get-og-data?url=${encodeURIComponent(url)}`)
            .then((response) => response.json())
            .then((data) => {
                setCache(url, data);
                setLoading(url, false);
            })
            .catch((error) => {
                console.error('Error fetching Open Graph data:', error);
                setCache(url, { error: true });
                setLoading(url, false);
            });
    }, [url, isValidUrl, cache, setCache, setLoading, loadingUrls]);

    if (!isValidUrl) {
        return <div className="link-preview-fail">Invalid URL</div>;
    }

    if (loadingUrls.has(url)) {
        return <div className="link-preview-loading">Loading...</div>;
    }

    const ogData = cache[url];
    if (!ogData || ogData.error) {
        return <div className="link-preview-fail">Failed to load preview</div>;
    }

    return (
        <div className="link-preview">
            <a href={url} target="_blank" rel="noopener noreferrer" title={url} onClick={(event) => handleLinkClick(event, url)}>
                {ogData.ogImage && ogData.ogImage.length > 0 && <img src={ogData.ogImage[0].url} alt="Link preview" />}
                <div className="preview__inner">
                    <h4>{ogData.ogTitle}</h4>
                    <p>{ogData.ogDescription}</p>
                </div>
            </a>
        </div>
    );
};

export default React.memo(LinkPreview);
